import api, { courseApi } from "./index";

export interface CourseV2ListParams {
  ids?: Array<string>;
  companyId?: string;
  responsibleId?: string;
  title?: string;
  enabled?: boolean;
  locale?: string;
  categoryIds?: Array<string>;
  createdAtMin?: Date;
  createdAtMax?: Date;
  updatedAtMin?: Date;
  updatedAtMax?: Date;
  offset?: number;
  limit?: number;
  sort?: "title" | "createdAt" | "updatedAt";
  order?: "ASC" | "DESC";
  options?: any;
}

export default (params: CourseV2ListParams, options?: any) => {
  return courseApi.Course.listCourses(
    params.ids,
    params.companyId,
    params.responsibleId,
    params.title,
    params.enabled,
    params.locale,
    params.categoryIds,
    params.createdAtMin,
    params.createdAtMax,
    params.updatedAtMin,
    params.updatedAtMax,
    params.offset,
    params.limit,
    params.sort,
    params.order,
    params.options
  );
};
